import { useEffect } from 'react';

export default function useDurationDrag(rootRef) {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;
    let drag = null;
    let suppressClick = false;
    let suppressTimer;
    const durationRow = (target) => target.closest?.('.select-plan__durations');
    const startDrag = (event) => {
      const row = durationRow(event.target);
      if (event.button !== 0 || !row || !root.contains(row) || row.scrollWidth <= row.clientWidth) return;
      drag = { row, x: event.clientX, scrollLeft: row.scrollLeft, moved: false };
    };
    const moveDrag = (event) => {
      if (!drag) return;
      const distance = event.clientX - drag.x;
      if (!drag.moved && Math.abs(distance) < 5) return;
      drag.moved = true;
      drag.row.classList.add('select-plan__durations--dragging');
      drag.row.scrollLeft = drag.scrollLeft - distance;
      event.preventDefault();
    };
    const endDrag = () => {
      if (!drag) return;
      drag.row.classList.remove('select-plan__durations--dragging');
      if (drag.moved) {
        suppressClick = true;
        window.clearTimeout(suppressTimer);
        suppressTimer = window.setTimeout(() => { suppressClick = false; }, 0);
      }
      drag = null;
    };
    const suppressDraggedClick = (event) => {
      if (!suppressClick || !durationRow(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    };
    root.addEventListener('mousedown', startDrag);
    window.addEventListener('mousemove', moveDrag);
    window.addEventListener('mouseup', endDrag);
    root.addEventListener('click', suppressDraggedClick, true);
    return () => {
      root.removeEventListener('mousedown', startDrag);
      window.removeEventListener('mousemove', moveDrag);
      window.removeEventListener('mouseup', endDrag);
      root.removeEventListener('click', suppressDraggedClick, true);
      window.clearTimeout(suppressTimer);
    };
  }, [rootRef]);
}
